"use client"

import React from "react"
import { useFormContext } from "react-hook-form"

import { cn } from "@productlane/lib/src/cn"

import type { ButtonProps } from "../button"
import { Button } from "../button"

export const SubmitButton = React.memo(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	React.forwardRef<any, Omit<ButtonProps, "type">>((props, ref) => {
		const { formState } = useFormContext()
		return (
			<Button
				{...props}
				type="submit"
				className={cn("max-w-lg sm:max-w-xs", props.className)}
				ref={ref}
				disabled={formState.isSubmitting || props.disabled}
				isLoading={formState.isSubmitting || props.isLoading}
			/>
		)
	}),
)
